import { Item } from '../../../models';
import { sortBy } from 'lodash';
import { SortSettings } from '../../../models/SortSettings';

export const sortAssets: (assets: Array<Item>, sortSettings: SortSettings) => Array<Item> = (assets, sortSettings) => {
  let newList = sortBy(assets, (asset: Item) => {
    switch (sortSettings.sortBy) {
      case 'title':
        return asset.title.toLowerCase();
      case 'categoryString':
        return asset.categoryString;
      case 'tagString':
        return asset.tagString;
      case 'durationString':
        return parseFloat(asset.durationString); // the strings themselves will not naturally be ordered correctly...
      case 'embargoDate':
        return asset.embargoDate;
      case 'expireDate':
        return asset.expireDate;
      case 'createdDate':
        return asset.createdDate;
      case 'publicationDate':
        return asset.publicationDate;
      default:
        throw `Unexpected sortBy: ${sortSettings.sortBy}`;
    }
  });
  if (sortSettings.descending) newList = newList.reverse();
  return newList;
};
